import eventBus from '@/plugins/eventBus';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueX from '@/store';

import routes from './routes';


Vue.use(VueRouter,);

const Router = new VueRouter({
  mode: 'history',
  routes,
},);

// very basic "setup" of a global guard
Router.beforeEach(async (to, from, next,) => {

  /* Impede o avanço caso a rota solicite confirmação */
  if (from.meta.checkBeforeRedirect) {
    eventBus.$emit('trigger-before-redirect',);
    const shouldRedirect = await VueX.getters['application/getBeforeRedirect']();
    if (!shouldRedirect) {
      return;
    }
  }

  // não checa se for roteamento pra mesma rota ou se for callback
  if (['callback', from.name,].includes(to.name,) || to.meta.isPublic) {
    // check if "to"-route is "callback" and allow access
    next();
  } else if (Router.app.$auth.isAuthenticated() && Router.app.$auth.isValidToken()) {
    // if authenticated allow access
    await VueX.dispatch('user/setUser', Router.app.$auth.getStoredUser(),);

    const userPermissions = VueX.getters['user/user'].permissions.map((permission,) => {
      return permission.name;
    },);

    const routerPermissions = to.meta.permissions;

    if (routerPermissions) {

      const hasRouterPermission = routerPermissions.filter((permission,) => {
        return userPermissions.includes(permission,);
      },);

      if (hasRouterPermission.length > 0) {
        next();
      } else {
        next('/lojas',);
      }
    }

    if (to.meta.panel === 'FRANCHISOR') {
      if (VueX.getters['user/user'].businessType === 'Franqueadora') {
        next();
      } else {
        Router.push({ name: 'list-stores', },);
      }
    }

    next();
  } else if (Router.app.$auth.isAuthenticated() && !Router.app.$auth.isValidToken()) {
    // trigger auth0 token renewal
    Router.app.$auth.renewToken().then(async (data,) => {
      await VueX.dispatch('user/setUser', data,);

      if (to.meta.panel === 'FRANCHISOR') {
        if (VueX.getters['user/user'].businessType === 'Franqueadora') {
          next();
        } else {
          Router.push({ name: 'list-stores', },);
        }
      }
      next();
    },);
  } else {
    // trigger auth0 login
    Router.app.$auth.login();
  }
},);

Router.afterEach((to,) => {
  /* Cria uma promise adiada até o usuário resolvê-la */
  if (to.meta.checkBeforeRedirect) {
    VueX.dispatch('application/addDeferedRedirect',);
  }
},);

export default Router;
